export default __webpack_public_path__ + "images/2B.c52172d.png";